import { tenantPrefixes } from '@/modules/healthblocks/ServerProvider'

export const isIntramuros =
  tenantPrefixes.some((prefix) => location.pathname.startsWith(prefix + '/intramuros')) ||
  location.pathname.startsWith('/intramuros')

/** Current base URL for intramuros pages */
// https://dev.mijnziekenhuis.be/intramuros/abcdefghijlmnopqrstuvwx
// https://dev.mijnziekenhuis.be/azmm/intramuros/abcdefghijlmnopqrstuvwx
export const intramurosBase = isIntramuros
  ? location.pathname.startsWith('/intramuros')
    ? location.pathname.split('/').slice(0, 3).join('/')
    : location.pathname.split('/').slice(0, 4).join('/')
  : ''

/** Intramuros key */
export const intramurosKey = isIntramuros ? location.pathname.split('/').at(-1) : ''
